
















import { resolveFullName } from '@/app/user/whoAmI'
import { Component, Vue } from 'vue-property-decorator'
import TedsLogo from './TedsLogo/TedsLogo.vue'

@Component({
  components: { TedsLogo },
})
export default class TedsLauncherWelcome extends Vue {
  public set: boolean = true

  public mounted(): void {
    this.set = this.$launcher.browserNotifications.hasVersion('welcome-launcher', 1)
  }

  public async close(): Promise<void> {
    await this.$launcher.browserNotifications.setVersion('welcome-launcher', 1)
    this.set = true
  }

  public get firstName(): string {
    const [firstName] = resolveFullName(this.$launcher.bootState.user).split(' ')
    return firstName
  }
}
